import { buttonIcon, buttonIconIcon } from '@mage-ui/styled-system/recipes';
import { ActionIcon } from '@mantine/core';
import type { ButtonProps } from '@/components/buttons';
import { IconRaw } from '@/components/data-display';
import { VisuallyHidden } from '@/components/misc';

export type ButtonIconProps = ButtonProps & {
  label: string;
  icon: string;
  classNames?: {
    root?: string;
    icon?: string;
  };
};

export const ButtonIcon = ({
  label,
  icon,
  classNames,
  ...props
}: ButtonIconProps) => {
  return (
    <ActionIcon
      classNames={{
        root: classNames?.root ?? buttonIcon(),
        icon: classNames?.icon ?? buttonIconIcon(),
      }}
      {...props}
    >
      <IconRaw name={icon} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </ActionIcon>
  );
};
